import { render, staticRenderFns } from "./Emailverify.vue?vue&type=template&id=a9fc0720"
import script from "./Emailverify.vue?vue&type=script&lang=js"
export * from "./Emailverify.vue?vue&type=script&lang=js"
import style0 from "./Emailverify.vue?vue&type=style&index=0&id=a9fc0720&prod&lang=scss"
import style1 from "./Emailverify.vue?vue&type=style&index=1&id=a9fc0720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports